// Bitrix CRM SOURCE_ID options offered in the "Bazani yuklash" (bulk lead) modal,
// and used to label the source shown on the application profile.
// `value` is the source string sent to the backend (stored in application.bitrix_source_id, then
// written to the deal's free-text "Источник(Manba)" field); `label` is the human name shown.
export const BITRIX_SOURCES = [
  { value: "WEB", label: "Веб-сайт" },
  { value: "CALL", label: "Звонок" },
  { value: "EMAIL", label: "Эл. почта" },
  { value: "ADVERTISING", label: "Реклама" },
  { value: "RECOMMENDATION", label: "По рекомендации" },
  { value: "TRADE_SHOW", label: "Выставка" },
  { value: "1", label: "TILDA" },
  { value: "2|TELEGRAM_UNLIM", label: "Telegram" },
  { value: "Instagram", label: "Instagram" },
  { value: "OTHER", label: "Другое" },
];

// Map a stored SOURCE_ID back to its readable label (for the profile display).
export function bitrixSourceLabel(value) {
  if (!value) return "—";
  const raw = String(value).trim();
  // Instagram in any encoding ("3", "3 (Instagram)", "3 (INSTAGRAM)", "Instagram") → "Instagram".
  if (raw.split(/[\s(]/)[0] === "3" || /instagram/i.test(raw)) return "Instagram";
  const found = BITRIX_SOURCES.find((s) => s.value === raw);
  return found ? found.label : raw;
}

export default BITRIX_SOURCES;
